var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 14,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.0043 50.0013C80.0043 66.5707 66.5706 80.0023 49.999 80.0023C33.4276 80.0023 19.9938 66.5707 19.9938 50.0013C19.9938 33.432 33.4276 20 49.999 20",
    stroke: "#141B34",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3906 20.1031C65.7413 20.0697 76.862 19.9159 78.5126 21.5664C80.1636 23.2169 80.0096 34.3357 79.9763 36.6863",
    stroke: "#141B34",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4755 20.0129C63.4229 22.3632 63.1785 33.4822 64.8155 35.1463C66.4525 36.8107 77.5722 36.7472 79.923 36.7331",
    stroke: "#141B34",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartRing);
export default __webpack_public_path__ + "static/media/smartRing.cb0afcfaa0df1387e5ad73b2f365e560.svg";
export { ForwardRef as ReactComponent };